import { orgActBookingCount, orgActBookingList, orgActListData } from '../../../../api/orgActAPI';
import { orgGuBookingList, orgGuidBookingCount, orgGuidListData } from '../../../../api/orgGuidAPI';
import errorHandle from '../../../../utils/errorHandle';

export const fetchActBookingData = async (selectedType, offSet, limit, setBookings, setLoading, selectedAct) => {
    setLoading(true);
    try {
        const response = await orgActBookingList(selectedType, limit, offSet, selectedAct);
        setBookings(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchActBookingsCount = async (selectedType, setTotalCount, setLoading, selectedAct) => {
    setLoading(true);
    try {
        const response = await orgActBookingCount(selectedType, selectedAct);
        setTotalCount(response.data.bookCount);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};

export const fetchActListdata = async (selectedGuide, setActsData, setLoading) => {
    setLoading(true);
    try {
        const response = await orgActListData();
        setActsData(response.data);
        setLoading(false);
    } catch (error) {
        setLoading(false);
        errorHandle(error);
    }
};
